import { authHeader, accountHeader, BASE_URL, handleResponse } from '@helpers/api';

export const menusService = {
    getAll,
    getAllUnpaged,
    getMenu,
    saveMenu,
    deleteMenu,
    duplicateMenu,
    setPublishExternally,
    getMenusForLocation,
    setLocationMenus,
    uploadItemImage,
    importMenu,
};

function getAll(page, pageSize) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader(),
    };
    return fetch(`${BASE_URL}api/menus?page=${page}&pageSize=${pageSize}`, requestOptions).then(handleResponse);
}

function getAllUnpaged() {
    const requestOptions = {
        method: 'GET',
        headers: authHeader(),
    };
    return fetch(`${BASE_URL}api/menus?returnAll=true`, requestOptions).then(handleResponse);
}

function getMenu(menuId) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader(),
    };
    return fetch(`${BASE_URL}api/menus/${menuId}`, requestOptions).then(handleResponse);
}

function saveMenu(data) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(data),
    };
    return fetch(`${BASE_URL}api/menus`, requestOptions).then(handleResponse);
}

function deleteMenu(menuId) {
    const requestOptions = {
        method: 'DELETE',
        headers: authHeader(),
    };
    return fetch(`${BASE_URL}api/menus/${menuId}`, requestOptions).then(handleResponse);
}

function duplicateMenu(menuId) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
    };
    return fetch(`${BASE_URL}api/menus/${menuId}/duplicate`, requestOptions).then(handleResponse);
}

function setPublishExternally(menuId, enabled) {
    const requestOptions = {
        method: 'PUT',
        headers: authHeader(),
        body: JSON.stringify({ enabled }),
    };
    return fetch(`${BASE_URL}api/menus/${menuId}/publish-externally`, requestOptions).then(handleResponse);
}

function getMenusForLocation(locationId) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader(),
    };
    return fetch(`${BASE_URL}api/menus/for-location/${locationId}`, requestOptions).then(handleResponse);
}

function setLocationMenus(locationId, menuIds) {
    const requestOptions = {
        method: 'PUT',
        headers: authHeader(),
        body: JSON.stringify(menuIds),
    };
    return fetch(`${BASE_URL}api/menus/for-location/${locationId}`, requestOptions).then(handleResponse);
}

function importMenu(data) {
    const user = JSON.parse(localStorage.getItem('user'));
    const requestOptions = {
        method: 'POST',
        headers: {
            Authorization: 'Bearer ' + user.token,
            ...accountHeader(),
        },
        body: data,
    };
    return fetch(`${BASE_URL}api/menus/import`, requestOptions).then(handleResponse);
}

function uploadItemImage(data, menuId, itemId) {
    const user = JSON.parse(localStorage.getItem('user'));
    const requestOptions = {
        method: 'POST',
        headers: {
            Authorization: 'Bearer ' + user.token,
            ...accountHeader(),
        },
        body: data,
    };
    return fetch(`${BASE_URL}api/menus/${menuId}/items/${itemId}/image`, requestOptions).then(handleResponse);
}
